import React, { Component } from 'react';
import { Tooltip as AntdTooltip } from 'antd';
import classNames from 'classnames';
import { TooltipProps } from 'antd/lib/tooltip';
import { ThemeContext } from 'app-themes';

import styles from './Tooltip.module.scss';

export class Tooltip extends Component<TooltipProps> {
	static contextType = ThemeContext;

	render() {
		const theme = this.context;

		return (
			<AntdTooltip
				{...this.props}
				overlayClassName={classNames(styles.tooltip, {
					[styles[`tooltip-${theme}`]]: theme !== '',
				})}
			>
				{this.props.children}
			</AntdTooltip>
		);
	}
}

export default Tooltip;
